import { request } from "@/api/server/index";

export default {
  //  V005_マイページ画面
  MyPageEdit: {
    // 業務カレンダー初期表示
    indexMyPageCalendar(params) {
      return request({
        url: "/mypage/searchUserContactCalendarList",
        data: params,
        method: "post"
      });
    },
    // マイページ 当日対応データ取得
    searchUserDailyContactsList(params) {
      return request({
        url: "/mypage/searchUserDailyContactsList",
        data: params,
        method: "post"
      });
    },
    // マイページ 対応漏れデータ取得
    searchUserLeakedContactsList(params) {
      return request({
        url: "/mypage/searchUserLeakedContactsList",
        data: params,
        method: "post"
      });
    },
    // マイページ 案内中案件データ取得
    searchUserProposalsList(params) {
      return request({
        url: "/mypage/searchUserProposalsList",
        data: params,
        method: "post"
      });
    },
    // マイページ 未読コメントある対応履歴データ取得
    searchNotReadCommentContactList(params) {
      return request({
        url: "/mypage/searchNotReadCommentContactList",
        data: params,
        method: "post"
      });
    },
    // システム推奨募集対象取得
    searchSystemRecommendTargetList(params) {
      return request({
        url: "/mypage/searchSystemRecommendTargetList",
        data: params,
        method: "post"
      });
    },
    //  案件未作成の満期更改対象証券（o43）の情報取得
    searchSecuritiesEligibleForMaturityList(params) {
      return request({
        url: "/mypage/searchSecuritiesEligibleForMaturityList",
        data: params,
        method: "post"
      });
    },
    //  案件未作成の満期更改対象証券（o43）の情報取得
    searchReturnIntentionList(params) {
      return request({
        url: "/mypage/searchReturnIntentionList",
        data: params,
        method: "post"
      });
    },
    // コメント確認ダイアログ（V005-1）の初期表示
    indexUserContactComments(params) {
      return request({
        url: "/mypage/indexUserContactComments",
        data: params,
        method: "post"
      });
    },
    // 「対応コメント」もしくは「団体対応コメント」レコードの更新
    updateContactOrOrgContact(params) {
      return request({
        url: "/mypage/updateContactOrOrgContact",
        data: params,
        method: "post"
      });
    },
    // 「自動抽出募集対象」レコードの更新
    updateTargetCustomer(params) {
      return request({
        url: "/mypage/updateTargetCustomer",
        data: params,
        method: "post"
      });
    },
    //  一括変更（b83）をクリックしたときの処理
    updateLifePolicyRenewalStatus(params) {
      return request({
        url: "/mypage/updateLifePolicyRenewalStatus",
        data: params,
        method: "post"
      });
    }
  }
};
